const clipboardImageExtensionByType: Readonly<Record<string, string>> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/gif': 'gif',
  'image/webp': 'webp',
};

export function handleTicketClipboardImagePaste(
  event: ClipboardEvent,
  selectImages: (files: File[]) => void,
): boolean {
  const images = ticketClipboardImageFiles(event.clipboardData);
  if (!images.length) return false;

  event.preventDefault();
  selectImages(images);
  return true;
}

export function ticketClipboardImageFiles(
  clipboardData: DataTransfer | null,
): File[] {
  if (!clipboardData) return [];

  const itemImages = Array.from(clipboardData.items ?? [])
    .filter((item) => item.kind === 'file')
    .map((item) => item.getAsFile())
    .filter((file): file is File => !!file && file.type.startsWith('image/'));

  const images = itemImages.length
    ? itemImages
    : Array.from(clipboardData.files ?? []).filter((file) =>
        file.type.startsWith('image/'),
      );

  return images.map(normalizeClipboardImageName);
}

function normalizeClipboardImageName(
  file: File,
  index: number,
): File {
  if (file.name.trim()) return file;

  const extension =
    clipboardImageExtensionByType[file.type] ??
    file.type.split('/')[1]?.replace(/[^a-z0-9]+/gi, '') ??
    'image';

  return new File(
    [file],
    `pasted-image-${index + 1}.${extension}`,
    {
      type: file.type,
      lastModified: file.lastModified,
    },
  );
}
